import { render, staticRenderFns } from "./base-field-date.vue?vue&type=template&id=562003cb&"
import script from "./base-field-date.vue?vue&type=script&lang=js&"
export * from "./base-field-date.vue?vue&type=script&lang=js&"
import style0 from "./base-field-date.vue?vue&type=style&index=0&id=562003cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports